import { render, staticRenderFns } from "./ModuleManagement.vue?vue&type=template&id=29599359"
import script from "./ModuleManagement.vue?vue&type=script&lang=ts"
export * from "./ModuleManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports